import type { CurrentUserAvatarProps } from "./current-user-avatar.type";

import { forwardRef } from "react";

import { useGetCurrentUser } from "@/entities/current-user";
import { UserAvatar } from "@/ui/user-avatar";

export const CurrentUserAvatar = forwardRef<
  HTMLSpanElement,
  CurrentUserAvatarProps
>((props, ref) => {
  const { currentUser } = useGetCurrentUser();

  return currentUser?.id ? (
    <UserAvatar ref={ref} {...props} user={currentUser} />
  ) : null;
});

CurrentUserAvatar.displayName = "CurrentUserAvatar";
